export default "__VITE_ASSET__DH3Vv02L__"